import { WasteWaterTreatmentPlantIcon } from '../icons'
// Done

export default {
  id: 'waste-water-treatment-plants',
  title: {
    en: 'Wastewater Treatment Plants',
    ar: 'محطات تنقية المياه العادمة'
  },
  Icon: WasteWaterTreatmentPlantIcon,
  description: {
    en: `<p>Wastewater treatment plants are designed to remove contaminants from used water and convert it into a cleaner, more usable state.</p><p>Jordan has built wastewater treatment plants across all 12 governorates with a total capacity of around 0.6 million cubic meters per day.</p>`,
    ar: ``
  },
  entries: [
    {
      id: 'ww1',
      position: { x: 436.8, y: 262 },
      title: {
        en: 'Central Irbid',
        ar: 'اربد المركزية'
      },
      yearOfOperation: '1987',
      capacity: '14,907'
    },
    {
      id: 'ww2',
      position: { x: 523.3, y: 249.1 },
      title: {
        en: 'Al-Ramtha',
        ar: 'الرمثا'
      },
      yearOfOperation: '1987',
      upgradeYear: ['2005'],
      capacity: '5,400'
    },
    {
      id: 'ww3',
      position: { x: 382.5, y: 363.7 },
      title: {
        en: 'Kufranjeh',
        ar: 'كفرنجة'
      },
      yearOfOperation: '1989',
      upgradeYear: ['2014'],
      capacity: '9,000'
    },
    {
      id: 'ww4',
      position: { x: 519, y: 379.7 },
      title: {
        en: 'East Jerash',
        ar: 'جرش الشرقية'
      },
      yearOfOperation: '1983',
      upgradeYear: ['1992', '2018'],
      capacity: '9,500'
    },
    {
      id: 'ww5',
      position: { x: 606, y: 302.8 },
      title: {
        en: 'Al-Mafraq',
        ar: 'المفرق'
      },
      yearOfOperation: '1988',
      upgradeYear: ['2016'],
      capacity: '6,500'
    },
    {
      id: 'ww6',
      position: { x: 601.6, y: 409.8 },
      title: { en: 'As-Samra', ar: 'السمرا' },
      yearOfOperation: '1985',
      upgradeYear: ['2008', '2015'],
      capacity: '346,000'
    },
    {
      id: 'ww7',
      position: { x: 480.4, y: 455.5 },
      title: { en: 'Al-Baq’a', ar: 'البقعة' },
      yearOfOperation: '1988',
      upgradeYear: ['2000'],
      capacity: '14,900'
    },
    {
      id: 'ww8',
      position: { x: 497.9, y: 469.8 },
      title: { en: 'Abu Nuseir', ar: 'أبو نصير' },
      yearOfOperation: '1986',
      capacity: '4,000'
    },
    {
      id: 'ww9',
      position: { x: 418.4, y: 480.6 },
      title: { en: 'As-Salt', ar: 'السلط' },
      yearOfOperation: '1981',
      upgradeYear: ['1994'],
      capacity: '7,600'
    },
    {
      id: 'ww10',
      position: { x: 421.9, y: 594.1 },
      title: { en: 'Madaba', ar: 'مادبا' },
      yearOfOperation: '1989',
      upgradeYear: ['2002'],
      capacity: '7,600'
    },
    {
      id: 'ww11',
      position: { x: 169.7, y: 1367.8 },
      title: { en: 'Aqaba', ar: 'العقبة ' },
      yearOfOperation: '1987',
      capacity: '9,000'
    },
    {
      id: 'ww12',
      position: { x: 374.6, y: 1198.1 },
      title: { en: 'Ma’an', ar: 'معان' },
      yearOfOperation: '1989',
      upgradeYear: ['2008'],
      capacity: '7,000'
    },
    {
      id: 'ww13',
      position: { x: 339.2, y: 996.2 },
      title: { en: 'Tafila', ar: 'الطفيلة' },
      yearOfOperation: '1988',
      capacity: '1,600'
    },
    {
      id: 'ww14',
      position: { x: 391.3, y: 814.1 },
      title: { en: 'Al-Karak', ar: 'الكرك' },
      yearOfOperation: '1988',
      upgradeYear: ['2015'],
      capacity: '5,500'
    },
    {
      id: 'ww15', //
      position: { x: 379.2, y: 249.5 },
      title: { en: 'Wadi Al-Arab', ar: 'وادي العرب' },
      yearOfOperation: '1999',
      capacity: 'وادي العرب'
    },
    {
      id: 'ww16',
      position: { x: 457.8, y: 487.5 },
      title: { en: 'Al Fuhais', ar: 'الفحيص' },
      yearOfOperation: '1997',
      capacity: '2,400'
    },
    {
      id: 'ww17',
      position: { x: 412.4, y: 545.3 },
      title: { en: 'Wadi As Seer', ar: 'وادي السير' },
      yearOfOperation: '1997',
      upgradeYear: ['2019'],
      capacity: '17,000'
    },
    {
      id: 'ww18',
      position: { x: 493.4, y: 319.5 },
      title: { en: 'Wadi Hasan', ar: 'وادي حسان' },
      yearOfOperation: '2001',
      capacity: '1,600'
    },
    {
      id: 'ww20',
      position: { x: 491.4, y: 578.6 },
      title: { en: 'Jiza', ar: 'الجيزة ' },
      yearOfOperation: '2009',
      capacity: '4,500'
    },
    {
      id: 'ww21',
      position: { x: 160.3, y: 1355.2 },
      title: { en: 'Aqaba Mechanical', ar: 'العقبة الميكانيكية' },
      yearOfOperation: '2005',
      capacity: '12,000'
    },
    {
      id: 'ww22',
      position: { x: 260.7, y: 1103.2 },
      title: { en: 'Wadi Musa', ar: 'وادي موسى' },
      yearOfOperation: '2000',
      capacity: '3,400'
    },
    {
      id: 'ww23',
      position: { x: 303.9, y: 1132.1 },
      title: { en: 'Al Shobak', ar: 'الشوبك' },
      yearOfOperation: '2000',
      capacity: '350'
    },
    {
      id: 'ww24',
      position: { x: 297.6, y: 1049.9 },
      title: { en: 'Al Mansourah', ar: 'المنصورة' },
      yearOfOperation: '2000',
      capacity: '50'
    },
    {
      id: 'ww25',
      position: { x: 432.6, y: 782.3 },
      title: { en: 'Al Lajoun', ar: 'اللجون' },
      yearOfOperation: '2005',
      capacity: '1,200'
    },
    {
      id: 'ww26',
      position: { x: 498.8, y: 264.8 },
      title: { en: 'Wadi Shallala', ar: 'وادي الشلالة' },
      yearOfOperation: '2015',
      capacity: '13,648'
    },
    {
      id: 'ww27',
      position: { x: 349.3, y: 272.3 },
      title: { en: 'North Shuneh', ar: 'الشونة الشمالية' },
      yearOfOperation: '2015',
      capacity: '1,200'
    },
    {
      id: 'ww28',
      position: { x: 501.2, y: 372.9 },
      title: {
        en: 'West Jerash / Al Me’rad',
        ar: 'جرش الغربية / المعراض'
      },
      yearOfOperation: '2010',
      capacity: '10,000'
    },
    {
      id: 'ww29',
      position: { x: 647, y: 374.2 },
      title: {
        en: 'Z’atary Refugee Camp',
        ar: 'مخيم لاجئين الزعتري'
      },
      yearOfOperation: '2015',
      capacity: '3,700'
    },
    {
      id: 'ww30',
      position: { x: 355.8, y: 438.8 },
      title: { en: 'Tel Al-Mantah', ar: 'تل المنطح' },
      yearOfOperation: '2011',
      capacity: '400'
    },
    {
      id: 'ww31',
      position: { x: 514.5, y: 590 },
      title: { en: 'South Amman', ar: 'جنوب عمان' },
      yearOfOperation: '2015',
      capacity: '52,000'
    },
    {
      id: 'ww32',
      position: { x: 769.5, y: 530.7 },
      title: { en: 'Azraq Refugee Camp', ar: 'مخيم لاجئين الأزرق' },
      yearOfOperation: '2015',
      capacity: '800'
    },
    {
      id: 'ww33',
      position: { x: 390.5, y: 833.5 },
      title: { en: "Mazar - Mu'ta", ar: 'مزار مؤتة' },
      yearOfOperation: '2015',
      capacity: '7,100'
    }
  ]
}
